"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceMatches = exports.EndsWith = exports.StartsWith = exports.Substring = exports.Matches = exports.LastPositionOf = exports.PositionOf = exports.Lower = exports.Upper = exports.SplitOnMatches = exports.Split = exports.Combine = exports.Concatenate = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var Concatenate = /** @class */ (function (_super) {
    __extends(Concatenate, _super);
    function Concatenate(json) {
        return _super.call(this, json) || this;
    }
    Concatenate.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, args.reduce(function (x, y) { return x + y; })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Concatenate;
}(expression_1.Expression));
exports.Concatenate = Concatenate;
var Combine = /** @class */ (function (_super) {
    __extends(Combine, _super);
    function Combine(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        _this.separator = (0, builder_1.build)(json.separator);
        return _this;
    }
    Combine.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var source, separator, _a, filteredArray;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.source.execute(ctx)];
                    case 1:
                        source = _b.sent();
                        if (!(this.separator != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.separator.execute(ctx)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = '';
                        _b.label = 4;
                    case 4:
                        separator = _a;
                        if (source == null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            filteredArray = source.filter(function (x) { return x != null; });
                            if (filteredArray.length === 0) {
                                return [2 /*return*/, null];
                            }
                            else {
                                return [2 /*return*/, filteredArray.join(separator)];
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Combine;
}(expression_1.Expression));
exports.Combine = Combine;
var Split = /** @class */ (function (_super) {
    __extends(Split, _super);
    function Split(json) {
        var _this = _super.call(this, json) || this;
        _this.stringToSplit = (0, builder_1.build)(json.stringToSplit);
        _this.separator = (0, builder_1.build)(json.separator);
        return _this;
    }
    Split.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var stringToSplit, separator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stringToSplit.execute(ctx)];
                    case 1:
                        stringToSplit = _a.sent();
                        return [4 /*yield*/, this.separator.execute(ctx)];
                    case 2:
                        separator = _a.sent();
                        if (stringToSplit && separator) {
                            return [2 /*return*/, stringToSplit.split(separator)];
                        }
                        return [2 /*return*/, stringToSplit ? [stringToSplit] : null];
                }
            });
        });
    };
    return Split;
}(expression_1.Expression));
exports.Split = Split;
var SplitOnMatches = /** @class */ (function (_super) {
    __extends(SplitOnMatches, _super);
    function SplitOnMatches(json) {
        var _this = _super.call(this, json) || this;
        _this.stringToSplit = (0, builder_1.build)(json.stringToSplit);
        _this.separatorPattern = (0, builder_1.build)(json.separatorPattern);
        return _this;
    }
    SplitOnMatches.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var stringToSplit, separatorPattern;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stringToSplit.execute(ctx)];
                    case 1:
                        stringToSplit = _a.sent();
                        return [4 /*yield*/, this.separatorPattern.execute(ctx)];
                    case 2:
                        separatorPattern = _a.sent();
                        if (stringToSplit && separatorPattern) {
                            return [2 /*return*/, stringToSplit.split(new RegExp(separatorPattern))];
                        }
                        return [2 /*return*/, stringToSplit ? [stringToSplit] : null];
                }
            });
        });
    };
    return SplitOnMatches;
}(expression_1.Expression));
exports.SplitOnMatches = SplitOnMatches;
// Length is completely handled by overloaded#Length
var Upper = /** @class */ (function (_super) {
    __extends(Upper, _super);
    function Upper(json) {
        return _super.call(this, json) || this;
    }
    Upper.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            return [2 /*return*/, arg.toUpperCase()];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Upper;
}(expression_1.Expression));
exports.Upper = Upper;
var Lower = /** @class */ (function (_super) {
    __extends(Lower, _super);
    function Lower(json) {
        return _super.call(this, json) || this;
    }
    Lower.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            return [2 /*return*/, arg.toLowerCase()];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Lower;
}(expression_1.Expression));
exports.Lower = Lower;
// Indexer is completely handled by overloaded#Indexer
var PositionOf = /** @class */ (function (_super) {
    __extends(PositionOf, _super);
    function PositionOf(json) {
        var _this = _super.call(this, json) || this;
        _this.pattern = (0, builder_1.build)(json.pattern);
        _this.string = (0, builder_1.build)(json.string);
        return _this;
    }
    PositionOf.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var pattern, string;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pattern.execute(ctx)];
                    case 1:
                        pattern = _a.sent();
                        return [4 /*yield*/, this.string.execute(ctx)];
                    case 2:
                        string = _a.sent();
                        if (pattern == null || string == null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, string.indexOf(pattern)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return PositionOf;
}(expression_1.Expression));
exports.PositionOf = PositionOf;
var LastPositionOf = /** @class */ (function (_super) {
    __extends(LastPositionOf, _super);
    function LastPositionOf(json) {
        var _this = _super.call(this, json) || this;
        _this.pattern = (0, builder_1.build)(json.pattern);
        _this.string = (0, builder_1.build)(json.string);
        return _this;
    }
    LastPositionOf.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var pattern, string;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pattern.execute(ctx)];
                    case 1:
                        pattern = _a.sent();
                        return [4 /*yield*/, this.string.execute(ctx)];
                    case 2:
                        string = _a.sent();
                        if (pattern == null || string == null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, string.lastIndexOf(pattern)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return LastPositionOf;
}(expression_1.Expression));
exports.LastPositionOf = LastPositionOf;
var Matches = /** @class */ (function (_super) {
    __extends(Matches, _super);
    function Matches(json) {
        return _super.call(this, json) || this;
    }
    Matches.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, string, pattern;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), string = _a[0], pattern = _a[1];
                        if (string == null || pattern == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, new RegExp('^' + pattern + '$').test(string)];
                }
            });
        });
    };
    return Matches;
}(expression_1.Expression));
exports.Matches = Matches;
var Substring = /** @class */ (function (_super) {
    __extends(Substring, _super);
    function Substring(json) {
        var _this = _super.call(this, json) || this;
        _this.stringToSub = (0, builder_1.build)(json.stringToSub);
        _this.startIndex = (0, builder_1.build)(json.startIndex);
        _this.length = (0, builder_1.build)(json['length']);
        return _this;
    }
    Substring.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var stringToSub, startIndex, length, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.stringToSub.execute(ctx)];
                    case 1:
                        stringToSub = _b.sent();
                        return [4 /*yield*/, this.startIndex.execute(ctx)];
                    case 2:
                        startIndex = _b.sent();
                        if (!(this.length != null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.length.execute(ctx)];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = null;
                        _b.label = 5;
                    case 5:
                        length = _a;
                        // According to spec: If stringToSub or startIndex is null, or startIndex is out of range, the result is null.
                        if (stringToSub == null ||
                            startIndex == null ||
                            startIndex < 0 ||
                            startIndex >= stringToSub.length) {
                            return [2 /*return*/, null];
                        }
                        else if (length != null) {
                            return [2 /*return*/, stringToSub.substr(startIndex, length)];
                        }
                        else {
                            return [2 /*return*/, stringToSub.substr(startIndex)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Substring;
}(expression_1.Expression));
exports.Substring = Substring;
var StartsWith = /** @class */ (function (_super) {
    __extends(StartsWith, _super);
    function StartsWith(json) {
        return _super.call(this, json) || this;
    }
    StartsWith.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, args[0].slice(0, args[1].length) === args[1]];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return StartsWith;
}(expression_1.Expression));
exports.StartsWith = StartsWith;
var EndsWith = /** @class */ (function (_super) {
    __extends(EndsWith, _super);
    function EndsWith(json) {
        return _super.call(this, json) || this;
    }
    EndsWith.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, args[1] === '' || args[0].slice(-args[1].length) === args[1]];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return EndsWith;
}(expression_1.Expression));
exports.EndsWith = EndsWith;
var ReplaceMatches = /** @class */ (function (_super) {
    __extends(ReplaceMatches, _super);
    function ReplaceMatches(json) {
        return _super.call(this, json) || this;
    }
    ReplaceMatches.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, args[0].replace(new RegExp(args[1], 'g'), args[2])];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ReplaceMatches;
}(expression_1.Expression));
exports.ReplaceMatches = ReplaceMatches;
//# sourceMappingURL=string.js.map